export type AppVersionID = number;

export interface AppVersion {
  created_on: string;
  updated_on: string;
  id: AppVersionID;
  label: string;
  minimum_label: string;
  remarks: string;
}
